"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @publicapi @module ng1 */ /** */
var ng_from_import = require("angular");
/** @hidden */ var ng_from_global = angular;
/** @hidden */ exports.ng = ng_from_import && ng_from_import.module ? ng_from_import : ng_from_global;
//# sourceMappingURL=angular.js.map